export enum ReportTabType {
    GenerateReport,
    ReportHistory,
    UserReports
}